import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";
// core components
import { AdminService } from "src/services/AdminService";
import Error from "src/components/General/Error";
import { iClinicProfile, iCommunityProfile, iPractitionerProfile, iProfileType } from "ps-shared";
import NetworkProfileTemplate from "src/pages/network/profile";
import CommunityProfileTemplate from "src/pages/community/profile";
import Loading from "src/components/General/Loading";
import { Link } from "gatsby";

interface NetworkProfilePageProps {
  slug: any;
  location: any; // gatsby link related object
}
interface NetworkProfilePageState {
  profile: iProfileType;
  errored: boolean;
  loaded: boolean;
  loading: boolean;
}
export default class NetworkProfilePage extends React.Component<NetworkProfilePageProps, NetworkProfilePageState> {
  public constructor(props: NetworkProfilePageProps) {
    super(props);
    this.state = {
      errored: false,
      loading: false,
      loaded: false,
      profile: null,
    };
  }

  public componentDidMount() {
    this.setState({
      loading: true,
    });
    AdminService.getProfileJson(this.props.slug)
      .then((profileJson) => {
        this.setState({
          profile: profileJson as iProfileType,
          loaded: true,
          loading: false,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          errored: true,
          loading: false,
        });
      });
  }

  public render() {
    return (
      <Container className="preview-mode">
        {this.state.loading && <Loading />}
        <div className={`${this.state.loaded === false ? "display-none" : ""}`}>
          {this.state.errored && <Error />}
          {this.state.loaded && (
            <Row>
              <Col xs="12" className="pm">
                You are viewing this profile in <b>preview mode!</b>
                <br />
                Something look off?{" "}
                <a href="mailto:info@psychedelic.support?subject=An issue with my profile preview">
                  Email a developer for help!
                </a>
                <br />
                Return to <Link to="/my/profiles/">Manage Profiles</Link>
              </Col>
              <Col xs="12">
                {(this.state.profile.profileType === "practitioner" || this.state.profile.profileType === "clinic") && (
                  <NetworkProfileTemplate
                    previewProfile={this.state.profile as iClinicProfile | iPractitionerProfile}
                    // eslint-disable-next-line no-restricted-globals
                    location={location}
                  />
                )}
                {this.state.profile.profileType === "community" && (
                  <CommunityProfileTemplate
                    previewProfile={this.state.profile as iCommunityProfile}
                    // eslint-disable-next-line no-restricted-globals
                    location={location}
                  />
                )}
              </Col>
            </Row>
          )}
        </div>
      </Container>
    );
  }
}
